const siteTitle = 'Afslut din ordre';

export default {
  mainTexts: {
    siteTitle: `${siteTitle}`,
    formTitle1: 'Fyld dine oplysninger',
    formTitle2: 'Du betaler her',
    btnForm: 'Fortsæt',
    btnForm2: 'Betal',
    priceText1: 'Betaling',
    priceText2: 'Total',
    footerTitle: 'Online betaling',
    footerText: 'Bekræft med dit kreditkort',
  },
  home: {
    placeholder: {
      firstName: 'fornavn',
      lastName: 'efternavn',
      email: 'e-mail',
      phone: 'telefon',
      city: 'by',
      address: 'adresse',
      zip: 'postnummer',
      continue: 'fortsæt',
      name: 'Navnet',
    },
    cardNumber: 'kortnummer',
    expirationDate: 'udløbsdato',
    name: 'navn',
    month: 'måned',
    year: 'år',
    cvv: 'CVV',
    confirmPayment: 'bekræft betaling',
  },
  validation: {
    requireEmail: 'Din e-mail er tom.',
    validEmail: 'E-mail er ugyldig.',
    requirePhone: 'Din telefon er tom.',
    minPhone: 'Telefonfelt skal være på mindst 10 tegn.',
    requireFirstName: 'Fornavnet er påkrævet.',
    validFirstName: 'Fornavnet er ugyldigt',
    requireLastName: 'Efternavnsfeltet er påkrævet.',
    validLastName: 'Efternavnsfeltet er ugyldigt',
    requireCity: 'Bybrikken er påkrævet.',
    validCity: 'Byfeltet er ugyldigt',
    requireAddress: 'Adressefeltet er påkrævet.',
    validAddress: 'Adressefeltet er ugyldigt',
    requireZip: 'Postnummerfeltet er påkrævet.',
    validZip: 'Postnummerfeltet er ugyldigt.',
    requireCard: 'Kortnummerfeltet er påkrævet.',
    minCard: 'Ikke nok symboler.',
    validCard: 'Kortnummerfeltet er ugyldigt.',
    requireMonth: 'Feltet udløbsmåned er påkrævet.',
    requireYear: 'Feltet udløbsår er påkrævet.',
    requireName: 'Navnefeltet er påkrævet.',
    validName: 'Navnefeltet er ugyldigt.',
    requireCvv: 'CVV-feltet er påkrævet.',
    validCvv: 'CVV-feltet er ugyldigt.',
    minFirstName: 'Fornavnsfeltet skal indeholde mindst 3 tegn.',
    minLastName: 'Efternavnsfeltet skal indeholde mindst 3 tegn.',
    minCity: 'Byfeltet skal bestå af mindst 3 tegn.',
    minAddress: 'Adressefeltet skal bestå af mindst 3 tegn.',
    minZip: 'Postnummerfeltet skal indeholde mindst 3 tegn.',
    minName: 'Navnefeltet skal indeholde mindst 3 tegn.',
    minCvv: 'CVV-feltet skal være på mindst 3 tegn.',
    specialFirstName: 'Feltets fornavn må ikke indeholde specialtegn',
    specialLastName: 'Efternavn-feltet må ikke indeholde specialtegn',
    specialName: 'Feltnavnet må ikke indeholde nogen specialtegn',
    specialCity: 'Byfeltet må ikke indeholde nogen specialtegn',
  },

  mask: {
    phone: '+45 99 999 99 99',
    zip: '9999',
    creditCard: '9999 9999 9999 9999',
    cvv: '9999',
  },

  getInTouch: {
    title: 'FÅ KONTAKT',
    firstName: 'Fornavn',
    lastName: 'Efternavn',
    email: 'E-mail',
    msg: 'Besked',
    send: 'Send',
    alreadyRegistered: 'Du har allerede registreret',
    unsubscribeLink: 'Unsubscribe link',
    worktime: 'Call center arbejder fra 10.00 til 17.00',
    phone: 'Telefon: Sofia +359 2 437 4207',
  },
};
